import { Box, Toolbar } from "@mui/material";
import { Link } from "react-router-dom";
import { ThemeToggle } from "./ThemeToggle";
import { SiteNavigation } from "./SiteNavigation";
import { useAuth } from "../auth/AuthContext";
import { UserMenu } from "../auth/components/UserMenu";
import { LoginButton } from "../auth/components/LoginButton";

export function SiteToolbar() {
  const { isAuthenticated, isLoading } = useAuth();
  return (
    <Toolbar
      sx={{
        gap: { xs: 0, sm: 1 },
        rowGap: 0.5,
        flexWrap: "wrap",
        px: { xs: 1.5, sm: 3 }
      }}
    >
      <Box
        component={Link}
        to="/"
        aria-label="ScottDB.Net home"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.75,
          flexShrink: 0,
          color: "text.primary",
          textDecoration: "none",
          fontWeight: 750,
          letterSpacing: "-0.04em",
          fontSize: { xs: "1rem", sm: "1.125rem" },
          whiteSpace: "nowrap",
          mr: "auto"
        }}
      >
        <Box
          component="img"
          src="/favicon-96x96.png"
          alt=""
          width={28}
          height={28}
          sx={{ width: { xs: 24, sm: 28 }, height: { xs: 24, sm: 28 } }}
        />
        <Box component="span">
          ScottDB
          <Box component="span" sx={{ color: "primary.main" }}>
            .Net
          </Box>
        </Box>
      </Box>
      <SiteNavigation />
      <ThemeToggle />
      {!isLoading && (isAuthenticated ? <UserMenu /> : <LoginButton />)}
    </Toolbar>
  );
}
